import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 20,
		fill: "#0066CC"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.9849 16.1411C23.4207 16.1411 22.937 15.9395 22.534 15.5365C22.131 15.1335 21.9295 14.6398 21.9295 14.0554C21.9295 13.471 22.131 12.9874 22.534 12.6045C22.937 12.2015 23.4207 12 23.9849 12C24.5693 12 25.063 12.2015 25.466 12.6045C25.869 12.9874 26.0705 13.471 26.0705 14.0554C26.0705 14.6398 25.869 15.1335 25.466 15.5365C25.063 15.9395 24.5693 16.1411 23.9849 16.1411ZM25.738 30.6801H30V33.733H18V30.6801H22.262V21.3401H18V18.2872H25.738V30.6801Z",
		fill: "var(--N0)"
	})]
});
export default SvgInfoFilled;
